<div class="success-page">
  <div class="success-card">
    <div class="check-circle">
      <mat-icon>check</mat-icon>
    </div>

    <h2 class="success-title">{{ 'Your request submitted successfully' | translate }}</h2>

    <button class="primary-btn" (click)="onRedirect()">
      {{ 'Go to My reservations' | translate }}
    </button>
  </div>
</div>
